/**
 * Single source of truth for app routes. Use these helpers everywhere
 * instead of hardcoding paths so future migrations are a one-line change.
 */
export const ROUTES = {
  home: "/",
  comparador: {
    root: "/comparador",
    ofertas: "/comparador/ofertas",
    despensa: "/comparador/despensa",
    canastas: "/comparador/canastas",
    product: (slug: string) => `/comparador/${slug}`,
  },
  categorias: "/categorias",
  cashback: "/cashback",
  cupones: "/cupones",
  ofertas: "/ofertas",
  viajes: "/viajes",
  historialPrecios: "/historial-precios",
  rufus: "/rufus",
  perfil: "/perfil",
  auth: { login: "/auth/login" },
  admin: {
    root: "/admin",
    featureFlags: "/admin/feature-flags",
  },
} as const;

/** Legacy path → new path. Kept here so the redirect config stays in sync. */
export const ROUTE_REDIRECTS: { from: string; to: string }[] = [
  { from: "/ofertas-todas", to: ROUTES.comparador.ofertas },
  { from: "/despensa", to: ROUTES.comparador.despensa },
];
